import React from "react";

function BestChoice() {
  return (
    <div id="bestChoice">
      <section className="best-choice-section">
      <div className="container">
        {/* Section Heading */}
        <div className="text-center mb-5">
          <h2 className="font-weight-bold  text-primary mb-4">
              why choose Corbiltek...?
              </h2>
          <div className="separator">
            <hr/>
            <i className="autora-icon-build separator-icon" />
            <span className="line" />
          </div>
          <p className="text-black-50" style={{fontSize: "18px"}}>
            With a strong foundation in civil and infrastructure projects, Corbiltek
            delivers end-to-end construction solutions — driven by innovation,
            precision, and commitment to excellence.
          </p>
        </div>

        {/* Features Row */}
        <div className="row text-center justify-content-center">
          <div className="col-md-4 mb-4">
            <div className="icon-box">
              <i className="autora-icon-quality icon" />
              <h5 className="text-secondary">ENGINEERING EXCELLENCE</h5>
              <p className="text-black-50" style={{ fontSize: "18px" }}>
                Our team combines advanced technology with engineering expertise
                to deliver durable and high-performing structures built to last.
              </p>
              <br/>
              <br/>
              <br/>
              <br/>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="icon-box">
              <i className="autora-icon-time icon" />
              <h5 className="text-secondary">ON-TIME DELIVERY</h5>
              <p className="text-black-50" style={{ fontSize: "18px" }}>
                We understand that time is critical in construction. Our structured
                planning and execution ensure that every project is completed on schedule
                — without compromising quality.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="icon-box">
              <i className="autora-icon-author icon" />
              <h5 className="text-secondary">TRUSTED EXPERTISE</h5>
              <p className="text-black-50" style={{ fontSize: "18px" }}>
                With years of experience across commercial, residential, and
                industrial projects, Corbiltek has earned the trust of clients
                through reliability and precision craftsmanship.
              </p>
              <br/>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}

export default BestChoice;
